import { types } from '../constants'

const index = {
  pending: `${types.list}_PENDING`,
  fulfilled: `${types.list}_FULFILLED`,
  rejected: `${types.list}_REJECTED`,
  setPage: types.page,
  setPerPage: types.perPage
}

const reducerKey = 'category'

export const list = {
  [index.pending]: ({ draft }) => {
    draft.industry[reducerKey].list.loading = true
    draft.industry[reducerKey].list.error = null
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.industry[reducerKey].list.data = action.payload.data

    draft.industry[reducerKey].list.pages = action.payload.pages
    draft.industry[reducerKey].list.total = action.payload.total
    draft.industry[reducerKey].list.totalGlobal = action.payload.totalGlobal
    draft.industry[reducerKey].list.page = action.payload.page

    draft.industry[reducerKey].list.loading = false
    draft.industry[reducerKey].list.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft.industry[reducerKey].list.loading = false
    draft.industry[reducerKey].list.error = action.payload
  },
  [index.setPage]: ({ draft, action }) => {
    draft.industry[reducerKey].list.page = action.payload
  },
  [index.setPerPage]: ({ draft, action }) => {
    draft.industry[reducerKey].list.perPage = action.payload
  }
}
